export default __webpack_public_path__ + "static/media/placeholder_store01-jp-mobile.7c6a6594.png";